'use strict';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = {
  props: {
    min: {
      type: [String, Number],
      default: 1
    },
    max: {
      type: [String, Number],
      default: 100
    },
    step: {
      type: [String, Number],
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [String, Number],
      default: 1
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disableStyle: function disableStyle() {
      if (this.disabled) {
        return {
          color: '#cccccc'
        };
      }
    },
    valueString: function valueString() {
      return this.value.toString();
    }
  },
  data: function data() {
    return {
      value: 1,
      isLess: false,
      isOver: false
    };
  },
  created: function created() {
    var self = this;
    self.value = parseInt(self.defaultValue, 10);
    if (self.disabled) {
      self.isLess = true;
      self.isOver = true;
    }
  },

  methods: {
    minusClicked: function minusClicked() {
      var self = this;
      if (self.disabled) {
        return;
      }
      var isMinOver = self.value <= self.min;
      var nowNum = self.value - parseInt(self.step, 10);
      if (isMinOver) {
        self.$emit('wxcStepperValueIsMinOver', { value: self.value });
      } else {
        self.value = nowNum;
        self.resetDisabledStyle();
      }
      // 由于此处已经减step
      if (nowNum <= self.min) {
        self.value = parseInt(self.min, 10);
        self.isLess = true;
      }
      self.$emit('wxcStepperValueChanged', { value: self.value });
    },
    plusClicked: function plusClicked() {
      var self = this;
      if (self.disabled) {
        return;
      }
      var isMaxOver = self.value >= self.max;
      var nowNum = self.value + parseInt(self.step, 10);
      if (isMaxOver) {
        self.$emit('wxcStepperValueIsMaxOver', { value: self.value });
      } else {
        self.value = nowNum;
        self.resetDisabledStyle();
      }
      // 由于此处已经加step
      if (nowNum >= self.max) {
        self.value = parseInt(self.max, 10);
        self.isOver = true;
      }
      self.$emit('wxcStepperValueChanged', { value: self.value });
    },
    onInput: function onInput(e) {
      this.correctInputValue(e.value);
    },
    onBlur: function onBlur(e) {
      this.correctInputValue(e.value);
    },
    correctInputValue: function correctInputValue(v) {
      var self = this;
      if (/^[1-9]\d{0,}$/.test(v) && parseInt(v, 10) >= self.min && parseInt(v, 10) <= self.max) {
        self.value = parseInt(v, 10);
      }
      self.$emit('wxcStepperValueChanged', { value: self.value });
    },
    resetDisabledStyle: function resetDisabledStyle() {
      this.isLess = false;
      this.isOver = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/script-loader.js!./node_modules/babel-loader/lib!./node_modules/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/wxc-stepper/index.vue
// module id = 196
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28